/** Keys of a result that is nothing but a failure report. */
const ENVELOPE_KEYS: ReadonlySet<string> = new Set([
  "error",
  "message",
  "code",
  "success",
  "found",
]);

function nonEmptyText(value: unknown): string | null {
  return typeof value === "string" && value !== "" ? value : null;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/**
 * Why a tool call failed, when the tool reported it in its result instead of
 * throwing; null for a result, and for an explicit `success: true`. Only an
 * explicit report counts:
 * `{ success: false, message? | error? }`, or a result made of nothing but
 * `{ error, message?, code?, found? }`. An `error` field among other data is business
 * data (a failed Workbook run's error), not a failed call.
 */
export function toolCallFailure(result: unknown): string | null {
  if (!isRecord(result) || result.success === true) return null;
  if (result.success === false) {
    return (
      nonEmptyText(result.message) ??
      nonEmptyText(result.error) ??
      "The tool reported a failure."
    );
  }
  const onlyEnvelope = Object.keys(result).every((key) =>
    ENVELOPE_KEYS.has(key),
  );
  return onlyEnvelope ? nonEmptyText(result.error) : null;
}
